import { loc } from "../i18n/survey";

const invitationComfortQuestion = {
  name: 'invitationcomfort',
  title: loc("quiz.invitationComfort.title"),
  type: 'radiogroup',
  choices: [
    {
      value: 'Yes',
      text: loc("quiz.shared.yes"),
    },
    {
      value: 'No',
      text: loc("quiz.shared.no"),
    },
    {
      value: 'It depends',
      text: loc("quiz.invitationComfort.choices.dependsOn"),
    },
  ],
  isRequired: true,
};

export default invitationComfortQuestion;